// @flow

import handleActions              from 'redux-actions/lib/handleActions';
import combineReducers            from 'redux-immutable/dist/combineReducers.js';
import type { SetFontSizeAction } from '../actions/accessibility';
import {
  largerFont,
  resetFont,
  setFontSize,
  smallerFont,
}                                 from '../actions/accessibility';

const fontSize = handleActions(
  {
    [String(setFontSize)](state, action: SetFontSizeAction) {
      return action.payload.fontSize;
    },
    [String(largerFont)](state) {
      return state + 0.1;
    },
    [String(smallerFont)](state) {
      return state - 0.1;
    },
    [String(resetFont)]() {
      return 1;
    },
  },
  1,
);

const accessibilityReducer = combineReducers({fontSize});


export default accessibilityReducer;



// WEBPACK FOOTER //
// ./src/modules/accessibility/store/reducers/accessibility.js